import filetools from '@/ts/tools/files';
import { useStorage } from '@vueuse/core';
import { defineStore } from 'pinia';
import { send } from '../api/send';
import upload from '../api/upload';

export const Profile = defineStore('profile', {
  state: () => ({         
    profile: useStorage('demo_profile', {}),            
    settings: useStorage('demo_settings', {}),            
    provider: useStorage('demo_provider', ''),            
    inited: useStorage('demo_init', {}),            
  }),
  
  getters: {

    god: (state) => state.profile.god,
    name:(state) => state.profile.title,
    
    // inits
    needInitLogin:(state) => state.profile.login.startsWith('#'),
    needInitYear:(state) => !state.profile.year,
    // needInitLevels:(state) => !state.inited.levels,
    
    init:(state) => {      
      if (!state.profile.id) return
      switch (true) {
        case state.needInitLogin: return true
        // case state.needInitYear: return true
        // case state.needInitLevels: return true
        default: return
      }      
    },
    

    providerIcon:(state) =>{
      let url = '/images/icons/providers'
      switch (state.provider) {
        case 'email':     return `${url}/email.svg`
        case 'google':    return `${url}/google.svg`
        case 'apple':     return `${url}/apple.svg`
        default:          return `${url}/tg.svg`
      }
    },

  
      
  },
  actions: {
    
    // login with google
    async google(token){
       let res = await send('account/login/google',{token})
       if (res.error) return res       
        this.profile = res.resp || {}
        this.provider = 'google'        
    },
    
    // login with apple
    async apple(token){
       let res = await send('account/login/apple',{token})
       if (res.error) return res
       this.profile = res.resp
       this.provider = 'apple'      
       return {}
    },
    
    // welcome
    async welcome(email){
       let res = await send('account/welcome',{email})
       if (res.error) return res       
       return res.go
    },
    
    // sign up
    async signup(email, pass){
       let res = await send('account/signup',{email, pass})
       if (res.error) return res       
       return res.go
    },
    
    // sign in
    async signin(email, pass){
       let res = await send('account/login',{email, pass})
       if (res.error) return res       
       if (res.go) return res.go
       this.profile = res.resp
       this.provider = 'email'
       return 
    },

    // get profile
    async refresh(){
       let res = await send('account/me',{})
       if (res.error) return
       this.profile = res.resp || {}
       return {}
    },
    
    // update profile
    async update(k, v){
       let res = await send('account/update',{k,v})
       if (res.error) return
       this.refresh()
       return {}
    },
    
    // update profile
    async avatar(files){
      console.log(files[0])
       let file = files[0]
       let bytes = await filetools.bytes(file)
       console.log('file bytes', bytes)
       let res = await upload.avatar(bytes)
       if (res.error) return
       let link = res.resp.link
       console.log('link', link)
       if (!link) return
             
       res = await send('account/update',{k:'image',v:link})
       if (res.error) return
       this.refresh()
       return {}
    },
    
    async logout(){
       let res = await send('account/logout')
       if (res.error) return res
       this.profile = {}
       this.settings = {}
       this.provider = ''      
       return {}
    },
    
    

  },
})

